import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { AuthContext } from "./AuthContext";

export const AuthProvider = ({ children }) => {
  // Inicializa com dados do localStorage, se existirem
  const [sessao, setSessao] = useState(() => {
    const sessaoSalva = localStorage.getItem("sessao");
    return sessaoSalva ? JSON.parse(sessaoSalva) : {};
  });

  // Atualiza o localStorage sempre que sessao mudar
  useEffect(() => {
    if (sessao && Object.keys(sessao).length > 0) {
      localStorage.setItem("sessao", JSON.stringify(sessao));
    } else {
      localStorage.removeItem("sessao"); // limpa ao fazer logout
    }
  }, [sessao]);

  return (
    <AuthContext.Provider value={{ sessao, setSessao }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};